export default {
  image: {
    s: 42,
    m: 54,
    l: 66
  }
};
